export function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDateTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return `${formatDate(d)} ${formatTime(d)}`;
}

export function formatCurrency(amount) {
  if (amount == null) return 'PHP 0.00';
  return `PHP ${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatPercentage(value) {
  if (value == null) return '0%';
  return `${Math.round(value * 100)}%`;
}

export function getStatusBadgeClass(status) {
  const statusMap = {
    confirmed: 'bg-[#DCFCE7] text-[#FFFFFF]',
    pending: 'bg-[#FEF3C7] text-[#B45309]',
    cancelled: 'bg-[#FEE2E2] text-[#FFFFFF]',
    completed: 'bg-[#DBEAFE] text-[#FFFFFF]',
    checked_in: 'bg-[#E0E7FF] text-[#4338CA]',
    active: 'bg-[#DCFCE7] text-[#FFFFFF]',
    inactive: 'bg-[#F3F4F6] text-[#64748B]',
    blocked: 'bg-[#FEE2E2] text-[#FFFFFF]',
    available: 'bg-[#DCFCE7] text-[#FFFFFF]',
  };
  return statusMap[status] || 'bg-[#F3F4F6] text-[#64748B]';
}

export function getInitials(name) {
  if (!name) return '';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function getDayName(index) {
  const days = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  return days[index] || '';
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
